import React from 'react';
import WeatherWidget from './weather/widget';
import { display_weather_widget } from '../../../services/services';

const OfferName = props => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Review',
    itemReviewed: {
      '@type': 'Product',
      name: props.offerName || 'Hotel (wakacjeamigos.pl)'
    },
    author: {
      '@type': 'Person',
      name: props.domainName || 'Jagoda Błaszczyk'
    },
    reviewRating: {
      '@type': 'Rating',
      ratingValue: props.starsRating || '0',
      bestRating: '10',
      worstRating: '0'
    },
    datePublished: new Date().toISOString()
  };

  return (
    <div>
      <div itemScope itemProp="review" itemType="http://schema.org/Review">
        <div className="hotel-and-weather">
          <div className="name">
            {props.placeName && (
              <h6 dangerouslySetInnerHTML={{ __html: props.placeName }} />
            )}
            {props.offerName && (
              <h3
                itemProp="name"
                dangerouslySetInnerHTML={{ __html: props.offerName }}
              />
            )}
            {props.starsRating && (
              <span className={`stars stars-${props.starsRating}`} />
            )}
          </div>
          {display_weather_widget(props.weather) && (
            <WeatherWidget
              weather={props.weather}
              departure_date={props.departure_date}
            />
          )}
        </div>
      </div>

      {/* Dane strukturalne w JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </div>
  );
};

export default OfferName;



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/offer_name.jsx